// every tunable value lives here so balancing the app never means hunting through files

export const APP_SETTINGS = {
  appName: "ChiX Desktop",
  dataFolderName: "ChiXDesktop",

  // first launch window size, after that the last size and spot are remembered
  windowWidth: 1680,
  windowHeight: 1000,
  windowMinWidth: 1000,
  windowMinHeight: 700,
  titleBarHeight: 38,
  titleBarColor: "#1c222c",
  titleBarSymbolColor: "#d6f7ff",

  // ubuntu helpers
  sshTimeoutSeconds: 15,
  serverPollSeconds: 15,
  journalLines: 80,

  // logs tab
  logMemoryEntries: 500,
  logFileMaxBytes: 2 * 1024 * 1024,

  // how often website tab logins are written to disk
  sessionFlushSeconds: 60,

  // how often tasks refresh in the background
  taskRefreshMinutes: 10,
  // how often linked (ics) calendars are fetched again
  calendarLinkSyncMinutes: 30,
  requestTimeoutSeconds: 20,
  planePageSize: 100,
  refQueueDelayMs: 1200,
  refQueueRetryDelayMs: 4500,

  // local server used by the chrome extension
  localServerPort: 47821,
  localServerHost: "127.0.0.1",
  maxReferenceBytes: 200 * 1024 * 1024,
  minVideoBytes: 48 * 1024,

  // quick capture shortcut
  quickCaptureHotkey: "CommandOrControl+Alt+N",
  inboxNoteName: "inbox",
  scratchpadNoteName: "scratchpad",
  stickyColors: ["yellow", "pink", "mint", "peach", "lilac", "sky"],

  // ai assistant, talks to claude with an anthropic api key
  defaultModelId: "claude-opus-5-5",
  chatEffort: "low" as const,
  chatMaxTokens: 8000,
  chatToolRounds: 8,
  // past this many prompt tokens the chat starts fresh instead of growing the bill
  chatResetTokens: 120_000,
  chatSearchHits: 40,
  chatReadLines: 200,
  maxNoteCharsInContext: 4000,
  calendarContextDays: 45,

  // ref scan: four pictures per request at 512px, bulk goes through the half price batch api
  refTagModelId: "claude-sonnet-5-5",
  refTagBatchSize: 60,
  refTagGroupSize: 4,
  refTagMaxPx: 512,
  refTagJpegQuality: 70,
  refTagPollMs: 30_000,
  refTagPauseMs: 1500,
  refTagMaxTokens: 700,
  // tagging stops for the month once the estimate passes this, chat keeps going
  claudeMonthlyBudgetUsd: 10,
  claudeConsoleUrl: "https://console.anthropic.com/settings/billing",

  // usd per million tokens. cache writes cost 1.25x input, batch halves everything
  claudePrices: {
    "claude-fable-5-1": { input: 10, output: 50, cacheRead: 0.25 },
    "claude-opus-5-5": { input: 4, output: 20, cacheRead: 0.2 },
    "claude-opus-5": { input: 5, output: 25, cacheRead: 0.5 },
    "claude-sonnet-5-5": { input: 2, output: 10, cacheRead: 0.2 },
    "claude-sonnet-5": { input: 2, output: 10, cacheRead: 0.2 },
    "claude-haiku-4-5": { input: 1, output: 5, cacheRead: 0.1 }
  } as Record<string, { input: number; output: number; cacheRead: number }>,
  refIndexBootDelayMs: 5000,
  // character pictures use the same model and size as refs. sheet pictures are looked at on their own,
  // the gallery backlog only when someone presses index, at most this many per press
  ocTagRunMax: 300,
  // live requests go up to this many pictures, more goes through the half price batch api
  ocTagLiveMax: 8,
  // rough cost of one picture through the batch api at 512px on sonnet, about 550 tokens in and 200 out at half price
  ocTagUsdPerPicture: 0.002,
  // the character sheet sent with their pictures, so chi knows who she is looking at. about 500 tokens at most, shared by four pictures
  ocTagSheetChars: 2000,
  ocTagSheetFieldChars: 300,
  // 2: captions written with the character sheet in hand, so pictures from version 1 get looked at again
  ocTagSchema: 2,
  refTagSchema: 3,
  maxRefNoteChars: 600,
  maxSeenPartChars: 120,
  jobStatuses: ["sketch", "wip", "review", "done"],
  sheetImageMaxPx: 720,
  galleryImageMaxPx: 1600,
  sheetImageMaxBytes: 1_200_000,

  // gesture drawing pulls full body poses from this pocketbase collection
  gestureBaseUrl: "https://pb.fractalstella.com",
  gestureCollection: "fullbody",
  gestureFileField: "field",
  gestureMaxPx: 1600,
  gestureCacheFiles: 600,

  // calculator
  calculatorHistorySize: 20,

  // notes autosave delay
  noteAutosaveMs: 800,

  // default web tabs shown on first run
  defaultWebTabs: [
    { id: "plane", name: "Plane", url: "https://plane.fractalstella.com" },
    { id: "pack", name: "Pack", url: "https://pack.genofrac.com" },
    { id: "x", name: "X", url: "https://x.com/notifications" }
  ]
};
